<div class="pw-row" *ngIf="!loading && hasAnything">

  <div class="pw-card">
    <div class="pw-head"><mat-icon>celebration</mat-icon> Celebrations <span class="pw-sub">next 7 days</span></div>
    <div class="pw-list" *ngIf="celebrations.length">
      <div class="pw-item" *ngFor="let c of celebrations">
        <span class="pw-av"><mat-icon>{{ c.icon }}</mat-icon></span>
        <span class="pw-who">
          <span class="pw-name">{{ c.name }}</span>
          <span class="pw-detail">{{ c.designation || '—' }}</span>
        </span>
        <span class="pw-when" [class.pw-when--today]="c.when === 'Today'">{{ c.when }}<ng-container *ngIf="c.tag"> · {{ c.tag }}</ng-container></span>
      </div>
    </div>
    <div class="pw-empty" *ngIf="!celebrations.length">No birthdays or anniversaries this week</div>
  </div>

  <div class="pw-card">
    <div class="pw-head"><mat-icon>emoji_people</mat-icon> New Joiners <span class="pw-sub">last 30 days</span></div>
    <div class="pw-list" *ngIf="newHires.length">
      <div class="pw-item" *ngFor="let h of newHires">
        <span class="pw-av pw-av--txt">{{ initials(h.name) }}</span>
        <span class="pw-who">
          <span class="pw-name">{{ h.name }}</span>
          <span class="pw-detail">{{ h.designation || 'Employee' }}</span>
        </span>
        <span class="pw-when">{{ h.when }}</span>
      </div>
    </div>
    <div class="pw-empty" *ngIf="!newHires.length">No new joiners this month</div>
  </div>

  <div class="pw-card">
    <div class="pw-head"><mat-icon>beach_access</mat-icon> Upcoming Holidays</div>
    <div class="pw-list" *ngIf="holidays.length">
      <div class="pw-item" *ngFor="let h of holidays">
        <span class="pw-who">
          <span class="pw-name">{{ h.name }}</span>
          <span class="pw-detail">{{ h.day }}</span>
        </span>
        <span class="pw-when">{{ h.when }}</span>
      </div>
    </div>
    <div class="pw-empty" *ngIf="!holidays.length">No upcoming holidays</div>
  </div>

</div>
